/* @flow */

import jwtDecode from 'jwt-decode';
import { createSelector } from 'reselect';


export const isLoggingUpSelector = (state: Object) => {
  const { isLoggingUp } = state.auth;
  return isLoggingUp;
};

export const logUpErrorSelector = (state: Object) => {
  const { logUpError } = state.auth;
  return logUpError;
};

export const shouldCompleteGettingStartedGuideSelector = (
  state: Object,
) => !state.auth.hasCompletedGettingStartedGuide && state.system.isInitComplete;

export const tokenSelector = (state: Object) => {
  const { tokensByUserId, currentUserId } = state.auth;

  return tokensByUserId[currentUserId];
};

export const isLoggedInSelector = (state: Object) => !!tokenSelector(state);

export const authorizationHeaderSelector = createSelector(
  tokenSelector,
  (token) => (token ? `Bearer ${token}` : undefined),
);

const decodedTokenSelector = createSelector(
  tokenSelector,
  (token) => token && jwtDecode(token),
);

export const userEmailSelector = (state: Object) => {
  const decodedToken = decodedTokenSelector(state);
  return decodedToken && decodedToken.email;
};

export const userIdSelector = (state: Object) => {
  const decodedToken = decodedTokenSelector(state);
  return decodedToken && decodedToken.id;
};

export const userNeedsToReauthenticateBySelector = (state: Object) => {
  const decodedToken = decodedTokenSelector(state);
  return decodedToken && new Date(decodedToken.exp * 1000);
};
